export default __webpack_public_path__ + "static/media/CatalystLogo-orange-black.a51a8082.png";